import { HttpClient } from "@angular/common/http";
import { TranslateLoader, TranslationObject } from "@ngx-translate/core";
import { catchError, forkJoin, map, Observable, of } from "rxjs";

export class EnvironmentTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private env: string,
  ) {}

  getTranslation(lang: string): Observable<any> {
    return forkJoin({
      base: this.http.get(`/assets/i18n/${lang}.json`),
      env: this.http
        .get(`/assets/i18n/${lang}.${this.env}.json`)
        .pipe(catchError(() => of({}))),
    }).pipe(map(({ base, env }) => this.deepMerge(base, env)));
  }

  deepMerge(target: any, source: any) {
    const output = { ...target };

    Object.keys(source).forEach((key) => {
      if (
        source[key] &&
        typeof source[key] === "object" &&
        !Array.isArray(source[key])
      ) {
        output[key] = this.deepMerge(output[key] || {}, source[key]);
      } else {
        output[key] = source[key];
      }
    });

    return output;
  }
}
